import AuthState from './state';

export const authInitialState: AuthState = {
  loggedIn: false,
  newUser: false,
};
